'use strict';

import ReactDOM from "react-dom/client";
import React from 'react';

import 'core-js/stable';
import 'regenerator-runtime/runtime';

import { persistStore } from 'redux-persist';

import { configureStore, history } from './_redux/_store';
import App from './App';

import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/styles.scss';

const store = configureStore();
const persistor = persistStore(store);

ReactDOM.createRoot(document.getElementById("app")).render(
    
         <App history={history} store={store} persistor={persistor} />
    
);
